import React, {FunctionComponent} from "react";
import {Grid, Typography} from "@mui/material";
import {AAccordion} from "@atiautomacao/ati-ui-library";
import {Equipment} from "../../Modules/Dashboard/Skid/EquipmentDetailsSkid/EquipmentDetailsSkidReducer";
import {MenuItemStatus} from "./Layout/menu/types/MenuItemStatus";
import {getStatusName} from "./Layout/menu/helpers/getStatusName";
import {DateFormat} from "../../Utils/DateFormatPatternUtils";

interface EquipmentBasicInfoProps {
    equipment?: Equipment;
    status?: MenuItemStatus;
    title?: string;
    // SGD-3616: na tela simplificada de inversor, Status e Última Atualização passam a viver nos
    // componentes de Comunicação/Alarmes, então são ocultados aqui (apenas nessa tela).
    hideStatusAndLastUpdate?: boolean;
}

// Work Sans vem do tema (com stack de fallback); o variant padrão evita o 'Borna' dos headings.
const labelSx = {
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: '143%',
    letterSpacing: '0.17px',
};

const valueSx = {
    ...labelSx,
    fontWeight: 700,
};

const EquipmentBasicInfo: FunctionComponent<EquipmentBasicInfoProps> = ({equipment, status, title = "Informações Básicas", hideStatusAndLastUpdate = false}) => {
    const rows = [
        ...(hideStatusAndLastUpdate ? [] : [
            {label: "Status", value: status ? getStatusName(status) : "-"},
            {label: "Última Atualização", value: equipment?.lastDateTime ? DateFormat(equipment.lastDateTime) : "-"},
        ]),
        {label: "Serie", value: equipment?.seriesNumber || "-"},
        {label: "Classe de Equipamento", value: equipment?.equipmentClass || "-"},
        {label: "Sigla", value: equipment?.abbreviation || "-"},
        {label: "Endereço IP", value: equipment?.utrIpAddress || "-"},
        {label: "Descrição", value: equipment?.description || "-"},
    ];

    return (
        <AAccordion title={title} defaultExpanded={false} ariaLabel="equipment-basic-info">
            <Grid container spacing={2}>
                {rows.map((row) => (
                    <Grid item xs={12} lg={6} xl={4} key={row.label}>
                        <Typography sx={labelSx}>{row.label}:</Typography>
                        <Typography sx={valueSx}>{row.value}</Typography>
                    </Grid>
                ))}
            </Grid>
        </AAccordion>
    );
}

export default EquipmentBasicInfo;
